import { Auditory } from "@entity/domain/models/quality-framework/auditory/auditory.model";

export class CreateAuditory {
    constructor(
        public certificationEntity: Auditory["certificationEntity"],
        public year: Auditory["year"],
        public entity: Auditory["entity"],
    ) {}
}
